import React from 'react';
import {
	Grid,
	Typography,
	TextField,
	Button,
	IconButton,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import SectionNamesEditable from './SectionNamesEditable';

const SectionEditor = ({
	index,
	section,
	handleUpdateSectionName,
	handleUpdateSectionVersion,
	handleUpdateSectionType,
	handleAddSectionElement,
	handleDeleteSectionElement,
	handleUpdateSectionElement,
}) => {
	const handleAddElement = () => {
		handleAddSectionElement(index);
	};

	const handleDeleteElement = (elementIndex) => {
		handleDeleteSectionElement(index, elementIndex);
	};

	const handleUpdateElement = (elementIndex, value) => {
		handleUpdateSectionElement(index, elementIndex, value);
	};

	return (
		<Grid item xs={12} key={index}>
			<Typography>
				<form>
					<Grid container spacing={2} alignItems="center">
						<Grid item xs={6}>
							<TextField
								label="Name"
								value={section.name}
								onChange={(e) => handleUpdateSectionName(index, e.target.value)}
								fullWidth
							/>
						</Grid>
						<Grid item xs={3}>
							<FormControl fullWidth>
								<InputLabel>Type</InputLabel>
								<Select
									value={section.type}
									onChange={(e) => handleUpdateSectionType(index, e.target.value)}
									fullWidth>
									<MenuItem value="text">Text</MenuItem>
									<MenuItem value="number">Number</MenuItem>
									<MenuItem value="textarea">TextArea</MenuItem>
									<MenuItem value="counter">Counter</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="subtitle1">Elements:</Typography>
							<List>
								<SectionNamesEditable
									section={section}
									handleUpdateElement={handleUpdateElement}
									handleDeleteElement={handleDeleteElement}
									handleAddElement={handleAddElement}
								/>
								<ListItem>
									<Button
										onClick={handleAddElement}
										startIcon={<Add />}
										variant="outlined"
										color="primary">
										Add Element
									</Button>
								</ListItem>
							</List>
						</Grid>
					</Grid>
				</form>
			</Typography>
		</Grid>
	);
};

export default SectionEditor;
